import { ISubmitRequestBody, IUploadDocumentRequestBody, IUploadLivenessRequestBody } from "../types/api/application.type";
import { apiPaths, ApplicationApiPaths, getApplicationApiPaths } from "../utils/apiUtils";
import { getUserDevice } from "../utils/helper";
import api from "./api";

export async function createApplicationApi(){
        const response = await api.post(getApplicationApiPaths(undefined,ApplicationApiPaths.CREATE_TEMPORARY_APPLICATION),{},{});
        if(response){
            return response.data;
        }else {
            return null;
        }
}

export async function uploadDocumentApi(
  id: string | undefined,
  retake: string | null,
  body: IUploadDocumentRequestBody,
) {
    const response = await api.put(`${getApplicationApiPaths(id,ApplicationApiPaths.UPLOAD_DOCUMENT)}?deviceType=${getUserDevice()}&retake=${retake}`, body, {});
    if (response) {
      return response // Return the response data
    } else {
      return null;
    }
}

export async function uploadLivenessSelfieApi(
  id: string,
  body: IUploadLivenessRequestBody
) {
    const response = await api.put(getApplicationApiPaths(id,ApplicationApiPaths.UPLOAD_LIVENESS),body,{});
    if (response) {
      return response; // Return the response data
    } else {
      return null;
    }
}


export async function getApplicationSummaryApi(customerId: string) {
    const response = await api.get(
      getApplicationApiPaths(customerId,ApplicationApiPaths.GET_SUMMARY)
    );
    if (response) {
      return response;
    } else {
      return null;
    }
}


export async function submitApplicationApi(body: ISubmitRequestBody) {
    const response = await api.post(getApplicationApiPaths(undefined,ApplicationApiPaths.SUBMIT), body, {});
    if (response) {
      return response;
    } else {
      return null;
    }
}


export async function getApplicationStatusApi(userId: string) {
 
    const response = await api.get(
      getApplicationApiPaths(userId,ApplicationApiPaths.GET_STATUS)
    );
    if (response) {
      return response;
    } else {
      return null;
    }
}


export async function lookupClientApi(code: string) {
  const response = await api.post(apiPaths.clientLookup, { code });
  return response?.data ?? null;
}

export async function setApplicantEmailApi(email: string) {
  const response = await api.post(apiPaths.clientApplicant, { email });
  return response?.data ?? null;
}

export async function getClientSessionApi() {
  const response = await api.get(apiPaths.session);
  return response?.data ?? null;
}

export async function endClientSessionApi() {
  try {
    await api.post(apiPaths.sessionEnd, {});
  } catch (error) {
    // Ending the journey must not depend on the server acknowledging it.
    console.error("Error ending client session", error);
  }
}

